import React, { useEffect, useState } from 'react';
import * as settingActions from '../../../actions/settingActions';
import SelectMultiple from '../../../components/SelectMultiple';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Translate } from 'react-redux-i18n';
import { KEY_NAME_SIDEBAR_MODULE } from '../../../constants/sidebarMenuConfigs';
import { checkFleetEnableModuleByName } from '../../../utils/commonFunctions';

const RestrictedZoneMultiSelect = ({
  auth,
  settingActions,
  onChange,
  disabled,
  values,
  style = {},
  restrictedZonesFixed = null
}) => {
  const [zoneOptions, setZoneOptions] = useState([]);

  useEffect(() => {
    const fetchZones = async () => {
      const result = await settingActions.getAllMapRestrictedZone(
        auth.selectedFleet.fleetId
      );
      const options =
        (result?.res || [])
          ?.filter((item) => {
            return item.activate === true;
          })
          ?.map((item) => ({ value: item._id, label: item.zoneName })) || [];
      setZoneOptions(options);
    };
    fetchZones();
  }, [auth.selectedFleet.fleetId, settingActions]);

  const handleOnChange = (value) => {
    const newValue = value.map((item) => item.value);
    onChange(newValue);
  };

  if(checkFleetEnableModuleByName(auth, KEY_NAME_SIDEBAR_MODULE.restrictedZone) === false) return null;
  return (
    <div style={{ ...style }}>
      <h3 style={{ fontSize: '20px', marginTop: '20px', color: '#e6e6e6' }} className="mb-sm">
        <Translate value="supplier.restrictedZoneAccess" />
      </h3>
      <p
        style={{
          fontSize: '14px',
          fontWeight: 400,
          color: '#98a2b3',
        }}
      >
        <Translate value="supplier.restrictedZoneAccessDes" />{' '}
      </p>
      <SelectMultiple
        onChange={handleOnChange}
        options={zoneOptions?.filter(
          (zone) => !restrictedZonesFixed || restrictedZonesFixed.includes(zone.value)
        )}
        value={
          zoneOptions.filter((zone) => {
            return values?.includes(zone.value);
          }) || []
        }
        isMulti={true}
        disabled={disabled}
      />
    </div>
  );
};

function mapStateToProps(state) {
  return {
    auth: state.auth,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    settingActions: bindActionCreators(settingActions, dispatch),
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RestrictedZoneMultiSelect);
